import { Modal as ModalRoot, type ModalProps } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalClose } from './ModalClose';
import { ModalDescription } from './ModalDescription';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
import { ModalTitle } from './ModalTitle';
import { ModalTrigger } from './ModalTrigger';

export const Modal = {
  Root: ModalRoot,
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter,
  Title: ModalTitle,
  Description: ModalDescription,
  Close: ModalClose,
  Trigger: ModalTrigger,
};

export type { ModalProps };
